import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./DesktopHeader.css";

import logo from "./Images/logo_bg1.png";
import LanguageDropdown from "./LanguageDropdown";
import {
    FaFacebook,
    FaYoutube,
    FaInstagram,
    FaLinkedin,
    FaPhone,
    FaMapMarkerAlt,
    FaChevronDown,
    FaHome,
    FaEnvelope,
    FaBuilding,
    FaLandmark,
    FaIndustry,
    FaCity,
    FaSearch
} from "react-icons/fa";

export default function DesktopHeader() {
    const [servicesDropdown, setServicesDropdown] = useState(false);
    const navigate = useNavigate();

    // Navigation functions
    const handleBuyClick = () => {
        navigate("/buy-properties");
        setServicesDropdown(false);
    };

    const handleRentClick = () => {
        navigate("/rent-properties");
        setServicesDropdown(false);
    };

    const handleIndustrialClick = () => {
        navigate("/properties/industrial");
        setServicesDropdown(false);
    };

    const handleResidentialClick = () => {
        navigate("/properties/residential");
        setServicesDropdown(false);
    };

    const handleCommercialClick = () => {
        navigate("/properties/commercial");
        setServicesDropdown(false);
    };

    const handleLandClick = () => {
        navigate("/properties/land");
        setServicesDropdown(false);
    };

    const handlePropertyManagementClick = () => {
        navigate("/property-management");
        setServicesDropdown(false);
    };

    const handlePropertyValuationClick = () => {
        navigate("/property-valuation");
        setServicesDropdown(false);
    };

    const handleLegalServicesClick = () => {
        navigate("/legal-services");
        setServicesDropdown(false);
    };

    const handleTermsConditionsClick = () => {
        navigate("/TermsConditions");
        setServicesDropdown(false);
    };

    const handleFeaturedPropertiesClick = () => {
        navigate("/FeaturedProperties");
        setServicesDropdown(false);
    };

    const handleNewLaunchesClick = () => {
        navigate("/LatestProperties");
        setServicesDropdown(false);
    };

    const handlePremiumListingsClick = () => {
        navigate("/FinanceCalculator");
        setServicesDropdown(false);
    };

    const handleInvestorZoneClick = () => {
        navigate("/PrivacyPolicy");
        setServicesDropdown(false);
    };

    const navLinks = [
        { path: "/", label: "Home", icon: <FaHome /> },
        {
            path: "#",
            label: "Property",
            icon: <FaChevronDown />,
            submenu: [
                { path: "/buy-properties", label: "Buy Properties", action: handleBuyClick },
                { path: "/rent-properties", label: "Rent Properties", action: handleRentClick },
                { path: "/property-management", label: "Property Management", action: handlePropertyManagementClick },
                { path: "/property-valuation", label: "Property Valuation", action: handlePropertyValuationClick },
                { path: "/legal-services", label: "Legal Services", action: handleLegalServicesClick }
            ]
        },
        { path: "/About", label: "About Us" },
        { path: "/propertie", label: "All Properties" },
        // { path: "/Gallery", label: "Gallery" },
        { path: "/FinanceCalculator", label: "Calculator" },
        // { path: "/Careers", label: "Careers" }
    ];

    // Property type cards data
    const propertyTypes = [
        {
            id: 1,
            path: "/properties/industrial",
            label: "Industrial Properties",
            description: "Warehouses & Manufacturing",
            icon: <FaIndustry className="desktop-property-icon" />,
            action: handleIndustrialClick,
            className: "desktop-industrial"
        },
        {
            id: 2,
            path: "/properties/residential",
            label: "Residential Properties",
            description: "Houses & Apartments",
            icon: <FaHome className="desktop-property-icon" />,
            action: handleResidentialClick,
            className: "desktop-residential"
        },
        {
            id: 3,
            path: "/properties/commercial",
            label: "Commercial Properties",
            description: "Offices & Retail",
            icon: <FaBuilding className="desktop-property-icon" />,
            action: handleCommercialClick,
            className: "desktop-commercial"
        },
        {
            id: 4,
            path: "/properties/land",
            label: "Plot & Land Properties",
            description: "Development Land",
            icon: <FaLandmark className="desktop-property-icon" />,
            action: handleLandClick,
            className: "desktop-land"
        }
    ];

    // Quick links data
    const quickLinks = [
        {
            id: 1,
            path: "/FeaturedProperties",
            label: "Featured Properties",
            badge: "new",
            action: handleFeaturedPropertiesClick
        },
        {
            id: 2,
            path: "/LatestProperties",
            label: "New Launches",
            badge: "hot",
            action: handleNewLaunchesClick
        },
        {
            id: 3,
            path: "/FinanceCalculator",
            label: "Finance Calculator",
            action: handlePremiumListingsClick
        },
        {
            id: 4,
            path: "/PrivacyPolicy",
            label: "Privacy Policy",
            action: handleInvestorZoneClick
        },
        {
            id: 5,
            path: "/TermsConditions",
            label: "Terms & Conditions",
            action: handleTermsConditionsClick
        }
    ];

    return (
        /* === यहाँ केवल एक wrapper div add किया है === */
        <div className="desktop-header-fixed-wrapper">
            {/* Top Info Bar - Desktop Only */}
            <div className="desktop-topbar">
                <div className="desktop-container">
                    <div className="desktop-topbar-left">
                        <span className="desktop-topbar-item">
                            <FaPhone className="desktop-topbar-icon" />
                            <span className="desktop-topbar-text calltext">Free Call +91 8487916787</span>
                        </span>
                        <span className="desktop-topbar-divider">|</span>
                        <span className="desktop-topbar-item">
                            <FaMapMarkerAlt className="desktop-topbar-icon" />
                            <span className="desktop-topbar-text">S/19, Crystal Plaza, Nr. Dominos pizza, GIDC, Kapodara Patiya, Ankleshwar.</span>
                        </span>
                    </div>

                    <LanguageDropdown />

                    <div className="desktop-topbar-right">
                        <span className="desktop-connect-text">Connect with us:</span>
                        <div className="desktop-social-icons">
                            <a
                                href="https://www.facebook.com/profile.php?id=61585309266874"
                                className="desktop-social-icon"
                                aria-label="Facebook"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaFacebook />
                            </a>
                            <a
                                href="https://www.youtube.com/channel/UCxYJ1sBCI22V-ynJ63XhHYg"
                                className="desktop-social-icon"
                                aria-label="YouTube"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaYoutube />
                            </a>
                            <a
                                href="https://www.instagram.com/bgrealstate360"
                                className="desktop-social-icon"
                                aria-label="Instagram"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaInstagram />
                            </a>
                            <a
                                href="https://www.linkedin.com/feed"
                                className="desktop-social-icon"
                                aria-label="LinkedIn"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FaLinkedin />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Navbar - Desktop Only */}
            <header className="desktop-navbar">
                <div className="desktop-container">
                    {/* Logo */}
                    <div className="desktop-logo">
                        <Link to="/" className="desktop-logo-link">
                            <div className="desktop-logo-image-wrapper">
                                <img src={logo} alt="BG RealState360 Logo" className="desktop-logo-image" />
                            </div>
                            <div className="desktop-logo-text-container">
                                <h1 className="desktop-company-name">BG RealEstate360</h1>
                                <p className="desktop-company-tagline">Industrial & Land Experts</p>
                                <span className="desktop-industry-badge">Est. 2001</span>
                            </div>
                        </Link>
                    </div>

                    {/* Desktop Navigation */}
                    <nav className="desktop-navigation">
                        <div className="desktop-nav-links">
                            {navLinks.map((link, index) => (
                                <div
                                    key={index}
                                    className="desktop-nav-item"
                                    onMouseEnter={() => link.submenu && setServicesDropdown(true)}
                                    onMouseLeave={() => link.submenu && setServicesDropdown(false)}
                                >
                                    {link.submenu ? (
                                        <>
                                            <button
                                                className="desktop-nav-link desktop-dropdown-trigger"
                                                onClick={() => setServicesDropdown(!servicesDropdown)}
                                            >
                                                <span className="desktop-nav-text">{link.label}</span>
                                                <FaChevronDown className="desktop-dropdown-icon" />
                                            </button>

                                            {/* Services Dropdown */}
                                            {servicesDropdown && (
                                                <div className="desktop-services-dropdown">
                                                    <div className="desktop-dropdown-content">
                                                        <div className="desktop-dropdown-grid">
                                                            {/* Properties Section */}
                                                            <div className="desktop-dropdown-column">
                                                                <h4 className="desktop-column-title">
                                                                    <FaCity className="desktop-column-icon" /> Properties
                                                                </h4>
                                                                <div className="desktop-property-types">
                                                                    {propertyTypes.map(property => (
                                                                        <button
                                                                            key={property.id}
                                                                            className={`desktop-property-type-card ${property.className}`}
                                                                            onClick={property.action}
                                                                        >
                                                                            {property.icon}
                                                                            <div className="desktop-property-info">
                                                                                <strong>{property.label}</strong>
                                                                                <span>{property.description}</span>
                                                                            </div>
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            </div>

                                                            {/* Quick Links */}
                                                            <div className="desktop-dropdown-column">
                                                                <h4 className="desktop-column-title">
                                                                    <FaSearch className="desktop-column-icon" /> Quick Links
                                                                </h4>
                                                                <div className="desktop-quick-links">
                                                                    {quickLinks.map(link => (
                                                                        <button
                                                                            key={link.id}
                                                                            className="desktop-quick-link"
                                                                            onClick={link.action}
                                                                        >
                                                                            {link.badge && (
                                                                                <span className={`desktop-link-badge ${link.badge}`}>
                                                                                    {link.badge === 'new' ? 'New' : 'Hot'}
                                                                                </span>
                                                                            )}
                                                                            {link.label}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <NavLink
                                            to={link.path}
                                            className={({ isActive }) =>
                                                `desktop-nav-link ${isActive ? 'desktop-active' : ''}`
                                            }
                                        >
                                            {link.icon && <span className="desktop-nav-icon">{link.icon}</span>}
                                            <span className="desktop-nav-text">{link.label}</span>
                                        </NavLink>
                                    )}
                                </div>
                            ))}
                        </div>
                    </nav>

                    {/* Action Buttons */}
                    <div className="desktop-nav-actions">
                        <button
                            className="desktop-contact-btn"
                            onClick={() => navigate("/ContactUs")}
                        >
                            <FaEnvelope /> <span>Get in Touch</span>
                        </button>
                    </div>
                </div>
            </header>
        </div>
    );
}